import { Controller } from "stimulus";
import hideElement from "../../functions/hideElement";
import showElement from "../../functions/showElement";
import disableElement from "../../functions/disableElement";
import enableElement from "../../functions/enableElement";

// Radio-group counterpart of selects--show-when-value: each hiddenDiv names the radio value that
// reveals it via data-show-on. Hidden inputs are disabled so they are not submitted.
export default class extends Controller {
  static get targets() {
    return ["radio", "hiddenDiv"];
  }

  connect() {
    this.checkVisibility();
  }

  checkVisibility() {
    const checked = this.radioTargets.find((radio) => radio.checked);
    const value = checked ? checked.value : null;

    this.hiddenDivTargets.forEach((target) => {
      if (value === target.dataset.showOn) {
        showElement(target);
        this.hiddenInputs(target).forEach(enableElement);
      } else {
        hideElement(target);
        this.hiddenInputs(target).forEach(disableElement);
      }
    });
  }

  hiddenInputs(container) {
    return [
      ...container.querySelectorAll("input"),
      ...container.querySelectorAll("select"),
      ...container.querySelectorAll("textarea")
    ];
  }
}
